import React, { useEffect } from "react";

import { Container } from "react-bootstrap";
import { Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";

const RedirectPage = (props) => {
 console.log(props);
  useEffect(() => {
    setTimeout(() => {
      window.open(props.location, '_blank', 'noreferrer');
    }, 3000);
  })

  return (
    <Container className="container py-5 h-100">
      <Card className="text-center">
        <Card.Body>
          <Card.Title>Redirecting to {props.location}</Card.Title>
          <Card.Text>
            You should be automatically redirected to <a href={props.location} target="_blank" rel="noreferrer">{props.location}</a> in 3 seconds. Sometimes the popup blocker can prevent that. If you are not redirected automatically, please click the button below to open the link in a separate window.
          </Card.Text>
          <Button 
            variant="success"
            className="shadow-lg"
            size="sm"
            href={props.location}
            target="_blank"
            // rel="noreferrer"
            // onLoad={openInNewTab}
          >Open Link</Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default RedirectPage;
